import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function CivilRightsPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['civil-rights']} />;
}
